import makeStyles from '@mui/styles/makeStyles';

export const modalFormActionsStyles = makeStyles((theme) => ({
    borderShadow: {
        borderTop: `1px solid ${theme.palette.grey[200]}`,
        boxShadow: '0 -2px 8px rgba(0,0,0,0.04)',
        flexShrink: 0,
        backgroundColor: theme.palette.background.paper
    },
    flexGridGap1: {
        display: 'flex',
        gridGap: theme.spacing(1)
    },
    padding2: {
        padding: theme.spacing(1.5, 3)
    }
}));
